import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Box} from 'reactjs-admin-lte'
import {Pagination,Button,ButtonToolbar,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Form,Modal} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
// import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup'
// import DatePicker from '../../component/element/DatePicker'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import PullStock from '../../component/element/PullStock'
import IframeModal from '../../component/element/IframeModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import PODocStore from '../../stores/PODocStore'
import ReportStore from '../../stores/ReportStore';
import ReportPurchaseOrderPage from '../report/ReportPurchaseOrderPage'
import Moment from 'moment';
import { Checkbox } from 'react-icheck';
import $ from 'jquery'
import Select from 'react-select'
import {connect} from 'react-redux'
import './Stock.css'
var NotificationSystem = require('react-notification-system');


const DEFAULT_ROW = 10
class StockAnyExportDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap = Date.now()
    this.stock_type_options = [{label:'เครื่องมือช่าง',value:'tool'},{label:'อะไหล่(ตามรุ่นรถ)',value:'part'},{label:'อะไหล่(ทั่วไป)',value:'genpart'},{label:'ประดับยนต์',value:'accessories'},{label:'เบ็ตเตล็ด',value:'officemate'},{label:'สีรถยนต์',value:'color'}]
  }

  initState(newState){
    
    let state = {
      activePage:1,
      totalPage:1,
      cur_data:[],
      pullStockShow:false,
      loading:false,
      showHistory:false,
      mpNo:'',      
      showNotice:false,
      shopName:'',
      rowBeep:-1,
      data:this.newEmptyRow(DEFAULT_ROW,'first'),
      options:[],
      doc:this.getEmptyDoc(),
      input:{car_registration_no:'',response_by:'',request_by:''},
      car_registration_no_list:[],
      stockApproverList:[],
      customerList:[],
      car_info:'',
      validQu:[],
      validDoc:{request_by:{formValid:null,validState:null},response_by:{formValid:null,validState:null}},
      isSave:true,
      showPO:false,
      defaultStockType:{isCheck:false,value:''},
      category:'',
      category_options:[],
      isSearchWork:false,
      showFixingList:false,
      checkFixingListAll:false,
      fixinglist:[]
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  }


  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.doc!==undefined){
      if(newProps.doc.recordid!==''){
        //console.log('onRe',newProps.doc)    
        let car_info = newProps.doc.brand+'/'+newProps.doc.model
        if (newProps.doc.brand===undefined||newProps.doc.model===undefined)
          car_info = ''

        this.setState({doc:newProps.doc,car_info:car_info})
      }else{
        this.setState({doc:this.getEmptyDoc(),car_info:'',data:this.newEmptyRow(DEFAULT_ROW)})        
      }
    }

    if(newProps.show && newProps.show!==this.props.show){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      this.loadStockNewRecordDoc()
      if(newProps.doc.recordid!==''){
        this.loadData(newProps.doc.recordid)
      }
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getToday(){
    return Moment().format('L LT').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
  }

  loadStockNewRecordDoc() {
    let {doc} = this.state
    this.setState({loading:true})
    StockStore.loadStockNewRecordDoc((result)=>{
      doc = this.getEmptyDoc()
      doc.lock_recordid = result.data.doc.lock_recordid
      this.setState({doc:doc,loading:false})
    },()=>{
      this.setState({loading:false})
    })
  }

  loadCarRegistrationNo(doc) {
    let that = this
    let car = []
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - that.car_info_timestmap)>2000){
      StockStore.loadCarRegistrationNo(doc.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap = Date.now()
      })
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  subscribeDocChannel(channel){
         
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    
    this.setState({mpNo:newSoNo,doc:doc})
  }

  newEmptyRow(number,first=''){
    let stock_type = ''
    let cat = ''
    if (first!=='first') {
      let {defaultStockType,category} = this.state
      if (defaultStockType.isCheck&&defaultStockType.value!=='') {
        stock_type = defaultStockType.value
        cat = category
      }  
    }  
    
    return new Array(number).fill(null).map((item,index)=>{
      return {container_quantity:'',container_unit:'',is_container:'0',quantity_per_container_unit:'',unit_type:'unit',itemnum:'',productcode:'',description:'',quantity:'',in_stock_quantity:'',stock_type:stock_type,unit:'',category:cat}
    })
  }

  getEmptyDoc(){
    return {work_no:'',description:'',doc_no:'',description:'',response_by:'',request_by:'',recordid:'',po:'',car_registration_no:'',lock_recordid:''}
  }

  handleSelect(pageSelect) { 
    let {cur_data} = this.state
    if (cur_data.length > 10) {
      let data = []
      let end = (pageSelect * 20) - 1
      let start = end - 19
      for (var i=start;i<=end;i++) {
        if (i<cur_data.length) {
          data.push(cur_data[i])
        }
      }
      this.setState({activePage:pageSelect, data:data})
    }
  }

  loadData(mpNo) {
    
    let that = this
    this.setState({ loading: true, mpNo: mpNo })
    StockStore.loadRecordDoc(mpNo, function (result) {
      let data = result.data
      data = data.map((item,index)=>{
        item = Object.assign({unit_type:'unit'},item)
        return item
      })
      if (result.data.length < DEFAULT_ROW) {
        data = data[0].itemlist.concat(that.newEmptyRow(DEFAULT_ROW - result.data.length))
      }
      ReactDOM.findDOMNode(that.pcInput[result.data.length]).focus();
      that.pcInput = new Array(data.length).fill('')
      that.setState({ loading: false,  data: data })
    })
  }

  onPrintClick(){
    let {soNo} = this.state
    if (process.env.NODE_ENV === "development") {
        window.open('https://demo-fast.bigfix.co/sriracha/pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }else{
        window.open('./pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }
  }

  onCustomerClick(){
    // this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  onExportClick(){

  }

  onSaveClick(){
    let {doc,data} = this.state
    this.saveStockAnyExport(doc,data)  
  }

  saveStockAnyExport(doc,data){
    let {validQu,validDoc,isSave} = this.state
    let {type,messages} = this.props
    if (isSave&&doc.lock_recordid!=='') {
      this.setState({isSave:false},()=>{
        let added_date = doc.doc_date
        if (added_date!==''&&added_date!==null&&added_date!==undefined) {
          let year = parseInt(added_date.substring(0,4)) + 543
          let month = added_date.substring(5,7)
          let day = added_date.substring(8,10)
          let time = added_date.substring(11,16)
          added_date = day + '/' + month + '/' + year + ' ' + time
        } else {
          added_date = this.getToday()
        }

        if (doc.request_by===''||doc.request_by===null||doc.request_by===undefined) {
          validDoc.request_by.formValid = 'formValidationError1'
          validDoc.request_by.validState = 'error'
          this.setState({validDoc:validDoc,isSave:true})
          return false
        }

        if (doc.response_by===''||doc.response_by===null||doc.response_by===undefined) {
          validDoc.response_by.formValid = 'formValidationError1'
          validDoc.response_by.validState = 'error'
          this.setState({validDoc:validDoc,isSave:true})
          return false
        }

        this.setState({loading:true})    

        let itemList = []
        let checkEmptyAll = true
        data.forEach(function(item,index) {
          if (item.itemnum!=='') {
            checkEmptyAll = false
          }
        })
        
        if (checkEmptyAll) {
            this.setState({loading:false,isSave:true})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Please Fill Item']+(type==='pickup'?messages['Pickup']:messages['Recieved']),
              level: 'error',
              position:'tc'
            });
        } else {
          let is_valid = false
          let is_more_in_stock = false
          let is_qty_0 = false
          this.setState({loading:false})
          if (type==='pickup') {
            data.forEach(function(item,index) {
              if (item.itemnum!==''&&item.quantity!==''&&item.quantity!==null&&item.quantity!==undefined) {
                if ((item.quantity*1)>(item.in_stock_quantity*1)) {
                  is_more_in_stock = true
                  validQu[index] = true
                  is_valid = true
                } else if ((item.quantity*1)<=0) {
                  is_qty_0 = true
                  validQu[index] = true
                  is_valid = true
                } else {
                  itemList.push(item)
                }
              } else if (item.itemnum!==''&&(item.quantity===''||item.quantity===null||item.quantity===undefined)) {
                validQu[index] = true
                is_valid = true
              }
            })
          } else {
            itemList = data
          }  

          if (is_valid&&type==='pickup') {
              this.setState({validQu:validQu,loading:false,isSave:true})
              if (is_more_in_stock) {
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message: messages['Not Enough Products In Stock'],
                  level: 'error',
                  position:'tc'
                });
              } else if (is_qty_0) {
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message: messages['Amount More 0'],
                  level: 'error',
                  position:'tc'
                });
              }
          } else {
            let postData = {item:itemList, meta:{lock_recordid:doc.lock_recordid,description:doc.description,request_by:doc.request_by, response_by:doc.response_by, 
              car_registration_no:doc.car_registration_no, wo:doc.work_no,      
              stock_type:'any', record_type:(type==='pickup'?'export':'import'), po:doc.po, added_date:added_date}}
            StockStore.recordDocProduct('any', postData, (result)=>{
                if (result.status === 'OK') {                
                  doc.doc_no = result.id
                  doc.recordid = result.id
                  this.setState({loading:false,doc:doc,isSave:true})
                  let msg = (type==='pickup'?messages['Pickup Successfully']:messages['Recieved Successfully'])
                  this._notificationSystem.addNotification({
                    title:messages['Notice'],
                    message: msg,
                    level: 'info',
                    position:'tc'
                  });

                }
            },(error)=>{
              this.setState({loading:false,isSave:true})
              let msg = (type==='pickup'?messages['Pickup Fail']:messages['Recieved Fail'])
              this._notificationSystem.addNotification({
                title:messages['Notice'],
                message: msg,
                level: 'error',
                position:'tc'
              });
            })
          }  
        }
      })   
    }
  }

  onCloseClick(){
    let {validDoc} = this.state
    validDoc.request_by.formValid = null
    validDoc.request_by.validState = null
    validDoc.response_by.formValid = null
    validDoc.response_by.validState = null
    this.setState({validQu:[],validDoc:validDoc,isSave:true})
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  getTotalPage() {
    let {cur_data} = this.state
    let totalPage = cur_data.length / 20
    totalPage = Math.round(totalPage)
    this.setState({totalPage:totalPage})
  }
  
  onDeleteRowClick(index){ 
    let {data,cur_data,validQu} = this.state
    validQu[index] = false
    cur_data.splice(index,1);
    data.splice(index,1);
    this.setState({data:data,cur_data:cur_data,validQu:validQu})    
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data,validQu} = this.state
    let value = e.target.value
    data[index][key] = value
    validQu[index] = false
    if(['end_quantity','begin_quantity'].includes(key)){
      data[index]['in_stock_quantity'] = (data[index]['begin_quantity']*1 - data[index]['end_quantity']*1).toFixed(2) 
    }
    this.setState({doc:doc,data:data,validQu:validQu})
  }

  onRowAdd(number){
    let {data} = this.state
    
    
    data = data.concat(this.newEmptyRow(number))

    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }


  onSearch(index, query) {
    let that = this
    StockStore.loadSearchAnyProductDetail(query, function (result) {
      let options = result.data.map((item, index) => {
        return { 
          id: item.itemnum, 
          productCode: item.productcode, 
          itemnum: item.itemnum, 
          categoryName: item.cat_name, 
          detail: item.description, 
          pricePerUnit: item.price_per_unit, 
          unit:item.unit, 
          quantity:item.quantity, 
          stock_type:item.stock_type,
          container_quantity:item.container_quantity,
          container_unit:item.container_unit,
          is_container:item.is_container,
          quantity_per_container_unit:item.quantity_per_container_unit
        }
      })
      that.setState({ options: options })
    })
  }

  onTypeaheadBlur(index){
    let {data} = this.state
    if (data[index].itemnum==''||data[index].itemnum==null||data[index].itemnum==undefined)
      data[index].description = ''
    this.setState({data:data})
  }

  onTypeaheadChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index].description = option[0].detail
      data[index].unit = option[0].unit
      data[index].in_stock_quantity = option[0].quantity
      data[index].stock_type = option[0].stock_type
      data[index].quantity = 1
      data[index].container_quantity = option[0].container_quantity
      data[index].container_unit = option[0].container_unit
      data[index].is_container = option[0].is_container
      data[index].quantity_per_container_unit = option[0].quantity_per_container_unit
      data[index].unit_type = 'unit'
      if(option[0].itemnum!==undefined){
        data[index].itemnum = option[0].id
        data[index].productcode = option[0].productCode
      }
    }
    this.setState({data:data})
  }

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data[index]['description'] = query
    this.setState({data:data})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode===13){
      this.onSaveClick()
    }
  }


  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no        
          that.setState({doc:doc,car_info:item.car_info,isSearchWork:true})
          ReactDOM.findDOMNode(that._description).focus()
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:that.props.messages['Car Registration Not Found'],isSearchWork:false})
        }
      })
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode===13){
      let {data} = this.state
      let {messages} = this.props
      let that = this,foundIndex = -1
      let productcode = data[index][key];
      //Finding duplicate
      
      data.map((item,iindex)=>{
        if(item.productcode===productcode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        
      }else{
        this.setState({loading:true})
        
        AutopartStore.loadStockProductCode('any',productcode,function(result){
          if(result.data.length>0){
            let item = result.data[0]  
            data[index].productcode = item.productcode
            data[index].description = item.description
            data[index].in_stock_quantity = item.quantity
            data[index].stock_type = item.stock_type
            data[index].itemnum = item.itemnum
            data[index].unit = item.unit
            data[index].container_quantity = item.container_quantity
            data[index].container_unit = item.container_unit
            data[index].is_container = item.is_container
            data[index].quantity_per_container_unit = item.quantity_per_container_unit
            data[index].unit_type = 'unit'
            if(index===data.length-1){
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index+1] = ''
            }
            that.setState({loading:false,data:data})
            ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
            
          }else{
            data[index].productcode = ''
            that.setState({loading:false,data:data})
            that._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Serial No Not Found']+' '+productcode+' '+messages['In Warehouse'],
              level: 'warning',
              position:'tc'
            });
          }
        })      
      }
      this.setState({data:data,rowBeep:foundIndex})
        setTimeout(function(){ 
          that.setState({rowBeep:-1})
        }, 1500);
    }
    
  }


  onMenuItemSelect(index){
    if('clearlist'===index){
      this.setState({clearShow:true})
    }else if("adjuststock"===index){
      this.setState({stockShow:true})      
    }else if("print"===index){
      let url = ''
      if (process.env.NODE_ENV === "development") {
        url  = './?startPage=PrintReportStockCheck&type='+this.props.stockType
      } else{
        url = './pdf/v2/?startPage=PrintReportStockCheck&type='+this.props.stockType
      }
      this.refs.iframe.loadUrl(url)
    }else if ("pullstock"===index) {
      this.setState({pullStockShow:true})
    }
  }

  onConfirmStockClear(){
    this.setState({clearShow:false,data:this.newEmptyRow(DEFAULT_ROW)})
    this.saveStockCheck([])
  }

  onConfirmStockSave(){
    let {data} = this.state 
    let {messages} = this.props
    let that = this
    StockStore.requestStockAdjust(this.props.stockType,data,function(result){
      data = data.map((item,index)=>{
        item.stock_quantity = item.quantity
        return item
      })
      that.setState({stockShow:false,data:data})
      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Adjust Quantity Of Warehouse'],
        level: 'info',
        position:'tc'
      });
    },function(){
      that.setState({stockShow:false})
    })
  }

  onTextBlur(index,e) {
    let {data} = this.state
    let that = this
    that.setState({loading:false})
    StockStore.loadMixpaintItemcode(data[index].productcode,e.target.value,function(result) {
      if (result.data.length>0) {
        data[index].last_quantity = result.data[0].end_quantity
      } else {
        data[index].last_quantity = ''
      }
      that.setState({data:data,loading:false})
    })
  }

  onDataChange(cat_id) {
    let that = this
    let {messages} = this.props
    ReportStore.loadStockList(this.props.stockType, "", cat_id, "", "", "", function(result) {
      let data = result.data.map((item,index)=>{
        item.stock_quantity = item.quantity
        item.quantity = ''
        item.detail = item.description
        return item
      })

      if(data.length <10) {
        data = data.concat(that.newEmptyRow(10-data.length))
        that.setState({data:data, totalPage:1})
        that.saveStockCheck(data)
      } else {
        let all_data = data
        let totalPage = all_data.length / 20
        totalPage = Math.round(totalPage)
        if (totalPage > 1) {
          data = []
          for (var i=0;i<20;i++) {
            data.push(all_data[i])
          }
        } else {
          totalPage = 1
        }
        that.setState({data:data, totalPage:totalPage, cur_data:all_data})
        that.saveStockCheck(all_data)
      }

      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Pull Data Successfully'],
        level: 'info',
        position:'tc'
      });
    })
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Cate']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }


  renderRemark(){
    let {description} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>{this.props.messages['Remark']}</ControlLabel>
          <InputGroup>            
            <FormControl value={description} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'description')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  onHideClick(e) {
    this.setState({pullStockShow:e})
  }

  onPrintClick(){
    let {doc} = this.state
    if (process.env.NODE_ENV === "development") {
      window.open('https://demo2.bigfix.co/korat/pdf/?sr='+doc.recordid+'&file=stockrecord_doc', '_blank');
    } else{
      window.open('./pdf/?sr='+doc.recordid+'&file=stockrecord_doc', '_blank');
    }
  
  }

  onHeadInputChagne(field,e){
    let {doc} = this.state
    doc[field] = e.target.value

    this.setState({doc:doc})
  }

  onStockTypeChange(index,e) {
    let {data} = this.state
    data[index].stock_type = e.value
    this.setState({data:data})
  }

  onCategoryRowChange(index,e) {
    let {data} = this.state
    data[index].category = e.value
    this.setState({data:data})
  }

  onFixinglistOpen() {
    let {doc} = this.state
    WorkdocStore.loadFixinglistWithstock(doc.work_no,(result)=>{
      let fixinglist = []
      fixinglist = result.data.map((item,index)=>{
        item = Object.assign({isCheck:false},item)
        return item
      })
      this.setState({showFixingList:true,fixinglist:fixinglist})
    })
  }

  onFixinglistSelect() {
    let {fixinglist,data} = this.state
    let itemSelect = []
    fixinglist.forEach((item,index)=>{
      let findDup = data.findIndex(x=>x.itemnum===item.itemnum)
      if (item.isCheck&&findDup===-1)
        itemSelect.push(item)
    })
    if (itemSelect.length>0) {
      let checkMap = false
      data.forEach((item,index)=>{
        if (item.itemnum===''&&item.description==='') {
          itemSelect.forEach((sitem,sindex)=>{
            if (sindex===0) {
              item.itemnum = sitem.itemnum
              item.description = sitem.detail
              item.quantity = sitem.quantity
              item.in_stock_quantity = sitem.in_stock_quantity
              item.productcode = sitem.productcode
              item.unit = sitem.unit
            }
          })
          checkMap = true
          if (itemSelect.length>0)
            itemSelect.splice(0,1)
        }
      })

      if (!checkMap) {
        itemSelect.forEach((item,index)=>{
          data.push({
            itemnum:item.itemnum,
            description:item.detail,
            quantity:item.quantity,
            in_stock_quantity:item.in_stock_quantity,
            productcode:item.productcode,
            unit:item.unit
          })
        })
      }

      this.setState({data:data},()=>{
        this.onFixinglistHide()
      })
    } else {
      this.onFixinglistHide()
    }
  }

  onFixinglistHide() {
    this.setState({showFixingList:false,checkFixingListAll:false})
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state
    let className = (item.itemnum > 0) ? '' : (item.description.length > 0) ? 'bg-gray' : ''

    if (rowBeep === index) {
      className = 'bg-yellow'
    }
    return className
  }

  onUnitChange(index,item,e) {
    let {data} = this.state
    data[index].unit_type = e.value
    if (e.value==='unit')
      data[index].unit = data[index].unit
    else
      data[index].unit = data[index].container_unit
    this.setState({data:data})
  }

  renderRowData(){
    let {data,options,validQu} = this.state
    let {type,messages} = this.props
    return(
      data.map((item,index)=>{ 
        let qty = item.in_stock_quantity
        if (item.is_container==='1') {
          if (item.unit_type==='unit') {
            qty = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
          } else {
            let _qty = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
            let _qty_per_container_unit = (item.quantity_per_container_unit===''||item.quantity_per_container_unit===null||item.quantity_per_container_unit===undefined||isNaN(item.quantity_per_container_unit)?0:item.quantity_per_container_unit)
            qty = _qty/_qty_per_container_unit
          }
          qty = this.getNumberFormat(qty)
        }
        return(
          <tr key={index} className={this.getRowClassName(item,index)}>
            <td className='text-center'>{index+1}</td>
            <td className='data-column'>
              <FormControl className='text-left' 
              ref={(input) => { this.pcInput[index] = input; }} 
              value={item.productcode} 
              onChange={this.onFormChange.bind(this,index,'productcode')}
              onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')}
              />
            </td>
            <td className='data-column' style={{display:(type==='pickup'?'none':'')}}>
              <Select
                disabled={item.itemnum>0?true:false}
                placeholder={messages['Select Stock Type']}
                clearable={false}
                value={item.stock_type}
                options={this.stock_type_options}
                onChange={this.onStockTypeChange.bind(this,index)}
              />
            </td>
            <td className='data-column' style={{display:(type==='pickup'?'none':'')}}>
              <Select
                disabled={item.itemnum>0?true:false}
                placeholder={messages['Select Category']}
                clearable={false}
                value={item.category}
                options={this.state.category_options}
                onChange={this.onCategoryRowChange.bind(this,index)}
              />
            </td>        
            <td className='data-column'>
              <AsyncTypeahead
                allowNew={this.props.type==='pickup'?false:true}
                multiple={false}
                newSelectionPrefix={messages['Add New Item']+' : '}
                promptText={messages['Keypress For Searching']}
                searchText={messages['Searching']}
                emptyLabel={messages['Item Not Found']+' : '+item.description}
                selected={[{ detail: item.description }]}
                options={options}
                labelKey="detail"
                onSearch={this.onSearch.bind(this, index)}
                onChange={this.onTypeaheadChange.bind(this, index)}
                onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                onBlur={this.props.type==='pickup'?this.onTypeaheadBlur.bind(this, index):()=>{}}
                placeholder=""
                renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
              />
            </td>
            <td className='data-column text-center'>
              <FormControl 
                type="number" 
                step="0.5" 
                className='text-center' 
                value={item.quantity} 
                onChange={this.onFormChange.bind(this,index,'quantity')}    
                style={{border:validQu[index]?'1px solid #d9534f':''}}    
              />
            </td>
            <td className='text-center' style={{verticalAlign:'middle'}}>{qty}</td>
            <td className={item.is_container==='1'?'text-left':'text-center'}>
              {item.is_container==='1'?
              <Select
                clearable={false}
                value={item.unit_type}
                options={[{label:item.unit+' (หน่วยย่อย)',value:'unit'},{label:item.container_unit+' (หน่วยใหญ่)',value:'container_unit'}]}
                onChange={this.onUnitChange.bind(this,index,item)}
              />
              :item.unit}
            </td>
            <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='close'/></Button></td>
          </tr>
        )
      })
    )
  }


  renderTable(){
    let {type,messages} = this.props
    let colSpan = (type==='pickup')?5:3
    return (
      <div className='table-responsive'>
      <table className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'180px'}}>{messages['Barcode/Product Code']}</th>
            <th className='text-center' style={{width:'200px',display:(type==='pickup'?'none':'')}}>{messages['Stock Type']}</th>
            <th className='text-center' style={{width:'200px',display:(type==='pickup'?'none':'')}}>{messages['Category']}</th>
            <th className='text-center' style={{width:'700px'}}>{messages['Item Name']}</th>
            <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>     
            <th className='text-center' style={{width:'100px'}}>{messages['Quantity Stock']}</th>
            <th className='text-center' style={{width:'150px'}}>{messages['Unit']}</th>            
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr >            
            <th colSpan={colSpan} className='text-right'>{messages['Total Of Item']}</th>
            <th colSpan={6}></th>
        </tr>
        </tfoot>
      </table>
      </div>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    let {isSearchWork} = this.state
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
            {isSearchWork?<Button bsStyle='primary' onClick={this.onFixinglistOpen.bind(this)}><FontAwesome name='search'/>&nbsp;ค้นหาจากทะเบียนรถ</Button>:''}
          </ButtonToolbar>       
        </Col>
      </Row>
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{this.props.messages['Stock Cut']}</span>)
    }else{
      return (<span/>)
    }
  }

  onTextChange(key,e) {
    let {doc,validDoc} = this.state

    if (doc==='')
      doc = this.getEmptyDoc()

    if (key==='request_by') {
      validDoc.request_by.formValid = null
      validDoc.request_by.validState = null
      this.setState({validDoc:validDoc})
    }

    if (key==='response_by') {
      validDoc.response_by.formValid = null
      validDoc.response_by.validState = null
      this.setState({validDoc:validDoc})
    }

    doc[key] = e.target.value
    this.setState({doc:doc})
    if (key==='car_registration_no') {
      this.loadCarRegistrationNo(doc)
      if(e.target.value==='')
        this.setState({car_info:''})
    }
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list,validDoc} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()
    
    if (key=='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          doc.work_no =  item.work_no
        }  
      })

      doc[key] = value      
      this.setState({doc:doc,car_info:car_info})
      ReactDOM.findDOMNode(this._description).focus()
    } else {

      if (key==='request_by') {
        validDoc.request_by.formValid = null
        validDoc.request_by.validState = null
        this.setState({validDoc:validDoc})
      }

      if (key==='response_by') {
        validDoc.response_by.formValid = null
        validDoc.response_by.validState = null
        this.setState({validDoc:validDoc})
      }

      doc[key] =  e
      this.setState({doc:doc})

      if (key==='mixed_by')
        this.refs._request_by.onFocus()
      else if (key==='request_by')
        this.refs._response_by.onFocus()
      else if (key==='response_by')
        this.refs._car_registration_no.onFocus()
    }
  }

  onEmpTextKeyPress(key,e) {
    if (e.charCode === 13) {
      e.preventDefault()
      let {messages} = this.props
      let {customerList,doc} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key==='request_by') {
          doc[key] = value
          this.refs._response_by.onFocus()
        } else if (key==='response_by') {
          doc[key] = value
          this.refs._car_registration_no.onFocus()
        } else if (key==='mixed_by') {
          doc[key] = value
          this.refs._request_by.onFocus()
        }
      } else { 
        doc[key] = ''

        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({doc:doc})
    }  
  }

  renderHeadTable() {
    let {doc,car_registration_no_list,customerList,validDoc} = this.state
    let {type,messages} = this.props
    return(
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} value={doc.lock_recordid} className="input-dark" /> 
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{type==='pickup'?messages['Pickup Date']:messages['Recieved Date']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={this.getToday()}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={validDoc.request_by.formValid}
                    validationState={validDoc.request_by.validState}
                  >
                    <ControlLabel>{type==='pickup'?messages['Requester']:messages['Requester']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={validDoc.request_by.formValid}
                    validationState={validDoc.request_by.validState}
                  >
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.request_by}
                          onChange={this.onTextChange.bind(this, 'request_by')}
                          onSelect={this.onTextSelect.bind(this, 'request_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'request_by')}
                          ref='_request_by'
                        />
                  </FormGroup>
                </Col>  
                <Col md={2}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.response_by}
                          onChange={this.onTextChange.bind(this, 'response_by')}
                          onSelect={this.onTextSelect.bind(this, 'response_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'response_by')}
                          ref='_response_by'
                        />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Car Registration']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                        <CKAutocomplete
                          top={'-35px'}
                          choiceStyle={{width:'350px'}}
                          items={car_registration_no_list}
                          value={doc.car_registration_no}
                          onKeyPress={this.onSearchCarKeyPress.bind(this)}
                          onChange={this.onTextChange.bind(this, 'car_registration_no')}
                          onSelect={this.onTextSelect.bind(this, 'car_registration_no')}
                          ref='_car_registration_no'
                        />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{this.state.car_info}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl inputRef={(input) => { this._description = input }} type="text" placeholder="" value={doc.description} onChange={this.onHeadInputChagne.bind(this,'description')} />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{display:(type==='pickup'?'none':'')}}>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Order Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <InputGroup>
                      <FormControl value={doc.po} onChange={this.onTextChange.bind(this,'po')} />
                      <InputGroup.Addon onClick={()=>{this.setState({showPO:true})}}><FontAwesome name='search' /></InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup style={{display:'inline-flex'}}>
                    <Checkbox
                      onChange={this.onDefaultStockTypeCheck.bind(this)}
                      checked={this.state.defaultStockType.isCheck}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"        
                      label={' '+messages['Auto Generated In Type']}          
                    />
                    &nbsp;
                    <Select
                      style={{width:'150px'}}
                      placeholder={messages['Select Stock Type']}
                      clearable={false}
                      value={this.state.defaultStockType.value}
                      options={this.stock_type_options}
                      onChange={this.onDefaultStockTypeChange.bind(this)}
                    />
                    &nbsp;
                    <Select
                      style={{width:'150px'}}
                      placeholder={messages['Select Category']}
                      clearable={false}
                      value={this.state.category}
                      options={this.state.category_options}
                      onChange={this.onCategoryChange.bind(this)}
                    />
                  </FormGroup>
                </Col>
              </Row> 
            </Form>
    )
  }

  onDefaultStockTypeCheck() {
    let {defaultStockType,data,category} = this.state
    if (defaultStockType.isCheck) {
      defaultStockType.isCheck = false
      defaultStockType.value = ''
      data = this.setStockType('')
      data = this.setCategory('')
      this.setState({data:data,category:'',category_options:[]})
    } else {
      defaultStockType.isCheck = true
      if (defaultStockType.value!=='')
        data = this.setStockType(defaultStockType.value)
      if (category!=='')
        data = this.setCategory(category)
      this.setState({data:data})
    }
    this.setState({defaultStockType:defaultStockType})    
  }

  setStockType(value) {
    let {data} = this.state
    data = data.map((item,index)=>{
      if (item.itemnum===''||item.itemnum<=0||item.itemnum===null)
        item.stock_type = value
      return item
    })
    return data
  }

  setCategory(value) {
    let {data} = this.state
    data = data.map((item,index)=>{
      if (item.itemnum===''||item.itemnum<=0||item.itemnum===null)
        item.category = value
      return item
    })
    return data
  }

  onDefaultStockTypeChange(e) {
    let {defaultStockType} = this.state
    defaultStockType.value = e.value
    if (defaultStockType.isCheck&&defaultStockType.value!=='') {
      this.setState({data:this.setStockType(defaultStockType.value)})
    }
    this.setState({defaultStockType:defaultStockType})
    this.loadCategory(defaultStockType.value)
  }

  loadCategory(category) {
    StockStore.loadCategory(category,(result)=>{
      let options = []
      options = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      this.setState({category_options:options})
    })
  }

  onCategoryChange(e) {
    let {category,defaultStockType} = this.state
    category = e.value
    if (defaultStockType.isCheck&&defaultStockType.value!=='') {
      this.setState({data:this.setCategory(category)})
    }
    this.setState({category:category})
  }

  onFixinglistCheckAll() {
    let {checkFixingListAll,fixinglist} = this.state
    let check = true
    if (checkFixingListAll) {
      check = false
      checkFixingListAll = false
    } else
      checkFixingListAll = true  
    
    fixinglist = fixinglist.map((item,index)=>{
      item.isCheck = check
      return item
    })
    this.setState({fixinglist:fixinglist,checkFixingListAll:checkFixingListAll})
  }

  onFixinglistCheck(index) {
    let {fixinglist} = this.state
    if (fixinglist[index].isCheck)
      fixinglist[index].isCheck = false
    else
      fixinglist[index].isCheck = true

    let checkAll = true
    fixinglist.forEach((item,index)=>{
      if (!item.isCheck)
        checkAll = false 
    })
    this.setState({fixinglist:fixinglist,checkFixingListAll:checkAll})      
  }

  renderPaging(){
    let {messages} = this.props
    return (
      <div>
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </div>
        </div>
    )
  }

  onSelectPO(poItem) {
    let {doc} = this.state
    doc.po = poItem.purchase_order_no
    PODocStore.loadPOOutRecord('IMPORT_STOCK',poItem.purchase_order_no,(result)=>{
      let new_data = []
      new_data = result.data.map((item,index)=>{
        return {description:item.detail,in_stock_quantity:'',itemnum:item.itemnum,productcode:item.productcode,quantity:item.quantity,stock_type:item.stock_type,unit:item.unit,stock_type:item.stock_type,category:''}
      })
      if (new_data.length < DEFAULT_ROW) {
        new_data = new_data.concat(this.newEmptyRow(DEFAULT_ROW - new_data.length))
      }
      this.setState({doc:doc,showPO:false,data:new_data})
    })
  }

  renderPOModal() {
    let {showPO,doc} = this.state
    let workNo = doc.work_no
    if (doc.car_registration_no==='')
      workNo = ''
    return(
        <Modal show={showPO} onHide={()=>{this.setState({showPO:false})}} dialogClassName='fullwidth-dialog'>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.messages['Select PO']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ReportPurchaseOrderPage
              workNo={workNo}
              mode={'modal'}
              docType={'stock-receive'}
              showNewButton={false}
              onSelectPO={this.onSelectPO.bind(this)}
            />
          </Modal.Body>
        </Modal>
    )
  }

  renderFixingListRowData() {
    let {fixinglist} = this.state
    if (fixinglist.length===0) {
      return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        fixinglist.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>
                    <Checkbox
                      onChange={this.onFixinglistCheck.bind(this,index)}
                      checked={item.isCheck}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"        
                      label=''          
                    />
              </td>
              <td className='text-left'>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
            </tr>
          )  
        })
      )
    }
  }

  renderFixingListTable() {
    let {checkFixingListAll} = this.state
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>  
            <tr>
              <th style={{width:'50px'}} className='text-center'>
                <Checkbox
                  checked={checkFixingListAll}
                  onChange={this.onFixinglistCheckAll.bind(this)}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"        
                  label=''
                />
              </th>
              <th style={{width:'250px'}} className='text-center'>รายการ</th>
              <th style={{width:'10px'}} className='text-center'>จำนวน</th>
            </tr>
          </thead>  
          <tbody>
            {this.renderFixingListRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderFixingListModal() {
    let {showFixingList} = this.state
    return(
      <Modal show={showFixingList} onHide={()=>{this.setState({showFixingList:false})}} dialogClassName='fullwidth-dialog'>
        <Modal.Header closeButton>
          <Modal.Title>เลือกอะไหล่จากใบงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderFixingListTable()}
        </Modal.Body>
        <Modal.Footer>
          <div className='pull-right'>
            <Button bsStyle='primary' onClick={this.onFixinglistSelect.bind(this)}><FontAwesome name='shopping-cart' />&nbsp;ใส่เข้าไปในรายการเบิก</Button>
            <Button onClick={this.onFixinglistHide.bind(this)}><FontAwesome name='close' />&nbsp;ปิด</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  render(){
    let {loading,stockShow,clearShow,doc,pullStockShow,isSave} = this.state
    let {type} = this.props
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    let {show,messages}  = this.props
    return (
      <div style={{display:show?'block':'none'}}>
        <Box loading={loading}>
          <Box.Header  className='text-center'>
            <Box.Title>
              {this.props.title}
            </Box.Title>
            <Box.Tools >
              <ButtonToolbar >                                            
                  <Button                             
                  className={'bg-maroon ' +(doc.recordid!==''?'':'hide')}
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                </Button>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            <div className='stock-any-export'>
              {this.renderHeadTable()}
              {this.renderTable()}
              {this.renderNewItemButton()}               
            </div>
            <IframeModal ref='iframe' title={messages['Print Document']} />
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ConfirmPopup show={stockShow} 
              title={messages['Confirm Title']} 
              message={messages['Want To Update The Stock From This Item']}
              confirmTitle={messages['Confirm']}
              onConfirm={this.onConfirmStockSave.bind(this)}
              onHide={()=>{this.setState({stockShow:false})}}        
              /> 
            <ConfirmPopup show={clearShow} 
              title={messages['Confirm Title']} 
              message={messages['Want To Start New Stock']}
              confirmTitle={messages['Confirm']}
              onConfirm={this.onConfirmStockClear.bind(this)}
              onHide={()=>{this.setState({clearShow:false})}}        
              /> 
            <PullStock
              show={pullStockShow}
              onHide={this.onHideClick.bind(this)}
              stockType={this.props.stockType}
              onDataChange={this.onDataChange.bind(this)}
            />      
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button style={{display:(doc.recordid!==''?'none':'')}} disabled={!isSave?true:false} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='wpforms' />&nbsp;{type==='pickup'?messages['Pickup']:messages['Recieved']}</Button> {/* style={{display:doc.recordid!==''?'none':''}} */}
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
            </ButtonToolbar>
          </Box.Footer>    
        </Box>        
        {this.renderPOModal()}
        {this.renderFixingListModal()}
      </div>
    )
  }
}

StockAnyExportDoc.defaultProps = {
  show:false,
  showHead: true,
  openInoutPrintAfterSubmit:true,
  title: 'รายการเบิกแม่สีผสม',
  type: 'pickup'
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockAnyExportDoc}),null,null,{withRef:true},
)(StockAnyExportDoc);



// WEBPACK FOOTER //
// ./src/view/stock/StockAnyExportDoc.js